'use client';

/*
  Fix applied based on: https://github.com/vercel/next.js/issues/58055#issuecomment-3133346877
  This seems to be a common issue w/ browser translation in NextJS.
  We would recommend customers to rely on Hire Go native translation, but we still need this fix
  for international customers.
*/
import { useEffect } from 'react';

function applyGoogleTranslateDOMPatch() {
  if (typeof Node === 'function' && Node.prototype) {
    const originalRemoveChild = Node.prototype.removeChild;

    Node.prototype.removeChild = function <T extends Node>(child: T): T {
      if (child.parentNode !== this) {
        console.warn(
          'Google Translate attempted to remove a child node from the wrong parent. Skipping.',
          {
            childNode: child?.nodeName,
            expectedParent: this?.nodeName,
            actualParent: child?.parentNode?.nodeName,
          }
        );
        return child;
      }

      return originalRemoveChild.call(this, child) as T;
    };

    const originalInsertBefore = Node.prototype.insertBefore;

    Node.prototype.insertBefore = function <T extends Node>(
      newNode: T,
      referenceNode: Node | null
    ): T {
      if (referenceNode && referenceNode.parentNode !== this) {
        console.warn(
          'Google Translate attempted to insert before a reference node from the wrong parent. Skipping.',
          {
            newNode: newNode?.nodeName,
            expectedParent: this?.nodeName,
            actualParent: referenceNode?.parentNode?.nodeName,
          }
        );
        return newNode;
      }

      return originalInsertBefore.call(this, newNode, referenceNode) as T;
    };
  }
}

export default function GoogleTranslateDOMPatch() {
  useEffect(() => {
    applyGoogleTranslateDOMPatch();
  }, []);

  return null;
}
